import { format, isValid, parseISO } from "date-fns";

export function loadStudentDirectoryVisibility(storageKey) {
  try {
    const raw = localStorage.getItem(storageKey);
    if (raw) return JSON.parse(raw);
  } catch {
    /* ignore */
  }
  return null;
}

export function formatStudentDate(value) {
  if (value == null || value === "") return "—";
  try {
    const raw = String(value).trim();
    let d = parseISO(raw);
    if (!isValid(d) && /^\d{4}-\d{2}-\d{2}/.test(raw)) {
      d = new Date(raw.replace(" ", "T"));
    }
    if (!isValid(d)) d = new Date(raw);
    return isValid(d) ? format(d, "PP") : "—";
  } catch {
    return "—";
  }
}

export function formatGender(g) {
  if (g == null || g === "") return "—";
  const s = String(g).trim();
  if (!s) return "—";
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

export function studentDirectoryCellValue(columnId, student) {
  switch (columnId) {
    case "created_at":
    case "mem_registration_date":
    case "date_of_birth":
      return formatStudentDate(student[columnId]);
    case "gender":
      return formatGender(student.gender);
    case "address":
      return student.address?.trim() ? student.address : "—";
    case "email":
      return student.email?.trim() ? student.email : "—";
    default:
      return student[columnId] ?? "—";
  }
}
